import React, { createContext, useContext, useEffect, useState } from "react";
import { loginPagoApi } from "../services/PagoService";

const PagoAuthContext = createContext({
  accessToken: null,
  error: null,
  loading: true,
});

export function PagoAuthProvider({ children }) {
  const [accessToken, setAccessToken] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loginPagoApi()
      .then((result) => {
        if (result.ok && result.data?.accessToken) {
          setAccessToken(result.data.accessToken);
          setError(null);
        } else {
          setError(result.error || "Error al obtener token de pago");
        }
      })
      .catch((err) => {
        setError(err.message || "Error al conectar con el servicio de pago");
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <PagoAuthContext.Provider value={{ accessToken, error, loading }}>
      {children}
    </PagoAuthContext.Provider>
  );
}

export function usePagoAuth() {
  const ctx = useContext(PagoAuthContext);
  if (!ctx) {
    throw new Error("usePagoAuth debe usarse dentro de PagoAuthProvider");
  }
  return ctx;
}
